export default "__VITE_ASSET__DwMi4BG$__"